import React from "react";
import FadeInSection from "../../../Components/FadeInSection";
import config from "../../../Data/AuthUser.js";


const getYouTubeVideoId = (url) => {
  if (!url) return null;

  // Handle different YouTube URL formats
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
};

const DashboardFeaturesViewMore = ({ data, onClose }) => {
  const IMAGE_API_URL = config.apiImageUrl;

  return (
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
      <div className="w-[0vw] md:w-1/6"></div>
      <div
          className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Feature Details
          </h2>
          <div className="border-t border-gray-200 mb-6"></div>
          <div className="flex flex-col space-y-8 flex-grow">
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Title</p>
              <p className="text-gray-800 w-2/3">{data.title || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Description
              </p>
              <p className="text-gray-800 w-2/3">{data.description || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Image</p>
              <p className="text-gray-800 w-2/3">{data.image || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Tutorial
              </p>
              <p className="text-gray-800 w-2/3">{data.Tutorial || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Created by
              </p>
              <p className="text-gray-800 w-2/3">{data.createdby || "--"}</p>
            </div>
          </div>
          {/* New division for YouTube video and Image */}
          <div className="flex flex-row md:flex-row space-x-6">
            {/* YouTube video section */}
            <div className="flex flex-col w-1/4 mb-4 md:mb-0">
              <p className="text-sm font-medium text-gray-500 mb-2">YouTube</p>
              <div className="aspect-video bg-gray-100 rounded">
                {data.Tutorial ? (
                  <iframe
                    className="w-full h-full rounded"
                    src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                      data.Tutorial
                    )}?autoplay=0`}
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-500">
                    No YouTube video available
                  </div>
                )}
              </div>
            </div>

            {/* Image section */}
            <div className="flex flex-col w-1/4">
              <p className="text-sm font-medium text-gray-500 mb-2">Image</p>
              <div className="aspect-video bg-gray-100 rounded">
                {data.image ? (
                  <img
                    src={`${IMAGE_API_URL}${data.image}`}
                    alt={"image d"}
                    className="w-full h-full object-cover rounded"
                  />
                ) : (
                  // <img
                  //   src={data.image}
                  //   alt="Blog image"
                  //   className="w-full h-full object-cover rounded"
                  // />
                  <div className="flex items-center justify-center h-full text-gray-500">
                    No image available
                  </div>
                )}
              </div>
            </div>
          </div>
          <button
            className="self-start px-4 py-2 bg-gray-300 text-black rounded-lg mt-6"
            onClick={() => {
              onClose();
            }}
          >
            Close
          </button>
        </div>
      {/* </FadeInSection> */}
    </div>
  );
};

export default DashboardFeaturesViewMore;
